import { Link } from "react-router-dom";

// V mark logo - stylized triangular V inspired by user reference
export function VMark({ size = 40, color = "currentColor" }) {
  return (
    <svg viewBox="0 0 60 60" width={size} height={size} fill="none" stroke={color} strokeWidth="2">
      <path d="M8 12 L30 52 L52 12" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22 12 L28 24" strokeLinecap="round" />
    </svg>
  );
}

export default function BrandLogo({ dark = false, size = "md", link = true }) {
  const color = dark ? "#FAFAFA" : "#0A0A0A";
  const marks = { sm: 22, md: 30, lg: 44 };
  const text = { sm: "text-base", md: "text-xl", lg: "text-3xl" };
  const body = (
    <div className="flex flex-col items-center leading-none select-none">
      <VMark size={marks[size]} color={color} />
      <div className={`font-display ${text[size]} tracking-[0.35em] font-bold mt-1`} style={{ color }}>
        VENVAY
      </div>
      <div className="w-8 h-px my-1" style={{ background: color, opacity: 0.5 }} />
      <div className="text-[9px] tracking-[0.3em] italic font-body" style={{ color, opacity: 0.7 }}>
        Be Rare. Be <span style={{ color: "#8B2E2E" }}>Venvay</span>.
      </div>
    </div>
  );
  return link ? <Link to="/" data-testid="brand-logo-link">{body}</Link> : body;
}
